import $ from 'jquery';
import {is_string, is_object} from './simple.functions';

$.fn.isChildOf = function (ref) {

    if (is_string(ref)) {
        return $.contains($(ref).get(0), this.get(0));
    } else if (is_object(ref)) {
        return $.contains(ref.get(0), this.get(0));
    }
    /*var parents = $(this).parents().get();
     for ( j = 0; j < parents.length; j++ )
     if ($(parents[j]).is(ref)) return true;
     return false;*/
};